export default "__VITE_ASSET__D__jKqO7__"